var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMedicalDrama = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Professions-Woman-Doctor-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Professions Woman Doctor 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 19.16a0.75 0.75 0 0 0 -0.75 0.75v2.5a0.75 0.75 0 0 0 1.5 0v-2.5a0.75 0.75 0 0 0 -0.75 -0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22.16a0.75 0.75 0 1 0 1.5 0 0.75 0.75 0 1 0 -1.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 19.66a0.75 0.75 0 1 0 1.5 0 0.75 0.75 0 1 0 -1.5 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.64 18.67 -2.9 -1a0.75 0.75 0 0 0 -0.95 0.47 0.75 0.75 0 0 0 0.47 0.95l2.88 1a3.26 3.26 0 0 1 2.11 3 0.75 0.75 0 0 0 1.5 0 4.78 4.78 0 0 0 -3.11 -4.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.31 17.7 -3 1a4.78 4.78 0 0 0 -3.06 4.45 0.76 0.76 0 0 0 0.75 0.75 0.76 0.76 0 0 0 0.75 -0.75 3.27 3.27 0 0 1 2.08 -3l3 -1a0.75 0.75 0 0 0 0.47 -0.95 0.74 0.74 0 0 0 -0.99 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49 9.13a0.76 0.76 0 0 0 0 1.06 0.74 0.74 0 0 0 1.06 0 0.59 0.59 0 0 1 0.56 0 0.74 0.74 0 0 0 1.06 0 0.76 0.76 0 0 0 0 -1.06 2 2 0 0 0 -2.68 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.91 9.13a0.76 0.76 0 0 0 0 1.06 0.75 0.75 0 0 0 1.06 0 0.59 0.59 0 0 1 0.56 0 0.74 0.74 0 0 0 1.06 0 0.76 0.76 0 0 0 0 -1.06 2 2 0 0 0 -2.68 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12 7.25C7.07 7.09 8 7 9 6.9a0.25 0.25 0 0 0 0.15 -0.43 4.58 4.58 0 0 1 -0.71 -0.87 0.25 0.25 0 0 0 -0.23 -0.12c-0.48 0 -1 0.09 -1.43 0.15v-3.2a7.38 7.38 0 0 1 1.17 -0.52 0.26 0.26 0 0 0 0.15 -0.14 4.09 4.09 0 0 1 0.71 -1.2 0.24 0.24 0 0 0 0 -0.3 0.25 0.25 0 0 0 -0.24 -0.11 8.69 8.69 0 0 0 -3 1.25 0.74 0.74 0 0 0 -0.3 0.6v4.5a0.74 0.74 0 0 0 0.27 0.57 0.76 0.76 0 0 0 0.58 0.17Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.93 1.77a0.26 0.26 0 0 0 0.15 0.14 8.67 8.67 0 0 1 1.17 0.51v3.21c-0.47 -0.06 -0.95 -0.1 -1.43 -0.15a0.25 0.25 0 0 0 -0.23 0.12 4.58 4.58 0 0 1 -0.71 0.87 0.23 0.23 0 0 0 -0.06 0.26 0.25 0.25 0 0 0 0.18 0.17c1 0.08 1.9 0.19 2.85 0.35H18a0.7 0.7 0 0 0 0.48 -0.18 0.74 0.74 0 0 0 0.27 -0.57V2a0.74 0.74 0 0 0 -0.3 -0.6 8.69 8.69 0 0 0 -3 -1.25 0.25 0.25 0 0 0 -0.27 0.11 0.24 0.24 0 0 0 0 0.3 4.09 4.09 0 0 1 0.75 1.21Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.1a3.25 3.25 0 1 0 3.25 3.25A3.26 3.26 0 0 0 12 0.1Zm0 5a1.75 1.75 0 1 1 1.75 -1.75A1.75 1.75 0 0 1 12 5.1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.22 16.18c1.68 0.41 3.57 -0.88 4.17 -1.63a0.51 0.51 0 0 0 0.09 -0.46 0.52 0.52 0 0 0 -0.32 -0.33A3.81 3.81 0 0 1 19.07 11a3.38 3.38 0 0 0 0.18 -1 1.86 1.86 0 0 0 -0.94 -1.81 0.74 0.74 0 0 0 -1 0.33 0.75 0.75 0 0 0 0.33 1s0.11 0.15 0.11 0.44a1.25 1.25 0 0 1 -0.56 1.09 1.74 1.74 0 0 0 -0.67 0.56 0.27 0.27 0 0 1 -0.29 0.09 12.65 12.65 0 0 0 -8.5 0 0.26 0.26 0 0 1 -0.29 -0.09 1.74 1.74 0 0 0 -0.67 -0.56A1.24 1.24 0 0 1 6.21 10a0.62 0.62 0 0 1 0.1 -0.44 0.75 0.75 0 1 0 -0.67 -1.34 1.87 1.87 0 0 0 -0.93 1.81 3.06 3.06 0 0 0 0.21 1 3.82 3.82 0 0 1 -2.08 2.67 0.52 0.52 0 0 0 -0.32 0.33 0.51 0.51 0 0 0 0.09 0.46c0.59 0.72 2.49 2 4.17 1.63a2.1 2.1 0 0 0 1.07 -0.62A6.76 6.76 0 0 0 12 17.66a6.76 6.76 0 0 0 4.15 -2.13 2 2 0 0 0 1.07 0.65Zm-5.24 0a5.62 5.62 0 0 1 -3.82 -2.68 0.26 0.26 0 0 1 0 -0.21 0.26 0.26 0 0 1 0.15 -0.14 11.18 11.18 0 0 1 7.38 0 0.28 0.28 0 0 1 0.15 0.15 0.26 0.26 0 0 1 0 0.21A5.6 5.6 0 0 1 12 16.16Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMedicalDrama);
export default ForwardRef;